module.exports = __webpack_public_path__ + "src/assets/img/m49.be705eb2.svg";